const ko = {
  ID_CHAT_SIDE_SLIDE_PERSONAL_CHAT_TITLE: "개인 채팅",
  ID_CHAT_SIDE_SLIDE_CATEGORY_WORLD: "월드",
  ID_CHAT_SIDE_SLIDE_CATEGORY_FOLLOWERS: "팔로워",
  ID_CHAT_SIDE_SLIDE_CATEGORY_FOLLOWING: "팔로잉",
  ID_CHAT_SIDE_SLIDE_START_CHAT: "채팅 시작",
};

export default ko;
